/*
 * @Author: pengzhihui
 * @Description: 
 * @Date: 2021-05-05 22:31:23
 */

import { Env, LifecyclesIF, LoadableApp, MicroApp, MicroAppEntryConfigs, singleMicroAppConfigObject } from "../interfaces";
import { mountRootParcel } from 'single-spa';
import { getContainer, getContainerXpath } from "../utils/app";
import { getMicroAppConfig } from "../appExplore";

const singleAppConfigPromiseMap = new Map<string, Promise<() => singleMicroAppConfigObject>>();

const defaultLifeCycles = {
    bootstrap: () => {
        return Promise.resolve()
    },
    mount() {
        return Promise.resolve()
    },
    unmount() {
        return Promise.resolve()
    }
};

export function loadSingleApp<T extends Record<string, any> >(
  app: LoadableApp<T> & {
    lifeCycles?: LifecyclesIF<T>
  }
): MicroApp {
    const { props } = app;
    const defaultContainer = document.createElement('div');
    const container = 'container' in app ? app.container : defaultContainer;
    const wrapSingleAppConfigForRemount = (config: singleMicroAppConfigObject): singleMicroAppConfigObject => {
        return {
        ...config,
        // empty bootstrap hook which should not run twice while it calling from cached micro app
        bootstrap: () => Promise.resolve(),
        };
    };
    const getDomElement = (): HTMLElement => {
        if ('container' in app) {
            const container = getContainer(app.container);
            if (!container) {
                return defaultContainer;
            }
            return container;
        };
        return defaultContainer;
    }

    const cacheLoadingFn = async (): Promise<singleMicroAppConfigObject> => {
        if (container) {
            const xpath = getContainerXpath(container);
            if (xpath) {
                const parcelConfigGetterPromise = singleAppConfigPromiseMap.get(`${app.appName}-${xpath}`);
                if (parcelConfigGetterPromise) return wrapSingleAppConfigForRemount((await parcelConfigGetterPromise)());
            }
        }
        const singleAppConfigObjectPromise = loadingSingleAppByConfig(app);
        if (container) {
            const xpath = getContainerXpath(container);
            if (xpath) singleAppConfigPromiseMap.set(`${app.appName}-${xpath}`, singleAppConfigObjectPromise);
        }
        return (await singleAppConfigObjectPromise)();
    };
  return mountRootParcel(cacheLoadingFn, { domElement: getDomElement(), ...props });
}

async function loadingSingleAppByConfig(app: { appId: number; appName: string; container?: string | HTMLElement, env: Env, customerConfig?: MicroAppEntryConfigs, lifeCycles?: any}): Promise<() => singleMicroAppConfigObject> {
    const configsFromApi = await getMicroAppConfig({
        env: app.env,
        coreId: app.appId,
        customerConfig: app.customerConfig
    });
    if (Object.keys(configsFromApi).length > 1) {
        console.warn('[DOLLY WARN] single app mode should only have one entry config, first one will be used!')
    }
    if (Object.keys(configsFromApi).length === 0) {
        console.warn('[DOLLY ERROR] can not found a entry config when mounte a single app, please check dolly setting in platform')
        return Promise.resolve(() => {
            return defaultLifeCycles;
        });
    }
    const firstAppId = Object.keys(configsFromApi)[0];
    const appEntryConfig = configsFromApi[Number(firstAppId)];
    const jsExports = await System.import(
        `${appEntryConfig.jsEntry![0]}`
    );
    return () => {
        return {
            ...jsExports.default,
            ...(app.lifeCycles || {}),
        }
    }
}